import supabaseClient from '@/api/supabaseClient.ts';
import { ClassRepository as SharedClassRepository } from '$/repositories/classRepository/ClassRepository.ts';

const classRepository = new SharedClassRepository(supabaseClient);
export default classRepository;
